/**
 * Ryan O'Dowd
 * 2024-12-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  const SPACING = globalScale * 16;
  const filtersBackgroundColor = colors.primaryLight; // @TODO: if darkmode

  return {
    container: {
      flexShrink: 1,
      margin: globalScale * 0,
      marginTop: globalScale * 0,
      padding: globalScale * 0,
      paddingTop: globalScale * 0,
    },
    expandedContainer: {
      width: '100%',
    },
    innerContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    expandedInnerContainer: {
      width: '100%',
      borderColor: colors.accent,
      borderWidth: globalScale * 2,
      borderRadius: SPACING / 2,
      padding: globalScale * (SPACING / 4),
      paddingTop: globalScale * SPACING,
      marginTop: SPACING,
      backgroundColor: filtersBackgroundColor,
    },
    titleWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: filtersBackgroundColor,
      borderColor: colors.accent,
      borderWidth: globalScale * 2,
      borderRadius: SPACING / 2,
      padding: SPACING / 4,
    },
    expandedTitleWrapper: {
      position: 'absolute',
      top: -1 * SPACING / 2 - 8,
      left: SPACING / 4,
    },
    titleLabel: {
      color: colors.accent,
      paddingHorizontal: globalScale * (SPACING / 4),
      fontSize: globalScale * 14,
      fontFamily: fonts.secondaryBold,
    },
    optionsWrapper: {
      flex: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: globalScale * 4,
    },
  };
};

export default getStyles;
